module.exports = __webpack_public_path__ + "img/19.947cca9f.jpg";